import template from './dynamicLinkAddPage.html';
import controller from './dynamicLinkAddPage.controller';
import './dynamicLinkAddPage.scss';

let dynamicLinkAddPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default dynamicLinkAddPageComponent;
